export default __webpack_public_path__ + "15128dba31e2071207aa613a37df7add.png";